export type ClassValue = string | number | null | false | undefined | ClassValue[];

export function cn(...inputs: ClassValue[]): string {
  const out: string[] = [];
  const walk = (value: ClassValue): void => {
    if (!value && value !== 0) return;
    if (Array.isArray(value)) {
      for (const v of value) walk(v);
      return;
    }
    out.push(String(value));
  };
  for (const v of inputs) walk(v);
  return out.join(' ');
}
